import {
  createApi,
  type ApiRequest as BaseApiRequest,
  type ApiResponse as BaseApiResponse,
} from "@superweb/api";
import type { ApiSchema } from "./generated";

export const {
  useAction,
  useCursorQuery,
  useOnDemandCursorQuery,
  useOnDemandQuery,
  useQuery,
  Api,
} = createApi<ApiSchema>({ baseUrl: "/api" });

export type ApiRequest<
  Url extends keyof ApiSchema,
  Method extends keyof ApiSchema[Url],
> = BaseApiRequest<ApiSchema, Url, Method>;

export type ApiResponse<
  Url extends keyof ApiSchema,
  Method extends keyof ApiSchema[Url],
> = BaseApiResponse<ApiSchema, Url, Method>;
